webpackJsonp([278322306582297,60335399758886],{

/***/ 324:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(629);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _layoutLayout = __webpack_require__(324);
	
	var _layoutLayout2 = _interopRequireDefault(_layoutLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_layout2.default, (0, _extends3.default)({}, props, _layoutLayout2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(69);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	
	var Layout = function (_React$Component) {
	    (0, _inherits3.default)(Layout, _React$Component);
	
	    function Layout() {
	        (0, _classCallCheck3.default)(this, Layout);
	        return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	    }
	
	    Layout.prototype.render = function render() {
	        this.loadStyle();
	        var content = this.props.children();
	        return React.createElement("div", { className: "app" }, this.renderBody(content));
	    };
	
	    Layout.prototype.renderBody = function renderBody(content) {
	        return content;
	    };
	
	    (0, _createClass3.default)(Layout, [{
	        key: "siteConfig",
	        get: function get() {
	            return this.props.data.siteConfig;
	        }
	    }]);
	    return Layout;
	}(React.Component);
	
	exports.Layout = Layout;

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Layout_1 = __webpack_require__(622);
	
	var Layout = function (_Layout_1$Layout) {
	    (0, _inherits3.default)(Layout, _Layout_1$Layout);
	
	    function Layout() {
	        (0, _classCallCheck3.default)(this, Layout);
	        return (0, _possibleConstructorReturn3.default)(this, _Layout_1$Layout.apply(this, arguments));
	    }
	
	    Layout.prototype.loadStyle = function loadStyle() {
	        return __webpack_require__(1078);
	    };
	
	    return Layout;
	}(Layout_1.Layout);
	
	exports.default = Layout;

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-layout-tsx-49e730d9f7a16bd6d7b8.js